import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../../../../hooks/useDeleteConfirm"
import { ApplicationPropertyDetail } from "../../../../../../models/ApplicationProperty"
import { ApplicationRolePermissionDetailGet } from "../../../../../../models/ApplicationRolePermission"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../../../models/Authorization"
import { UserInfo } from "../../../../../../models/User"
import { deleteEntity } from "../../../../../../utils/deleteEntity"
import { DiMaAddButton } from "../../../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../../../partials/EntityTab"

export function ApplicationRolePermissionProperties(props: {
  readonly applicationRolePermission: ApplicationRolePermissionDetailGet
  readonly reloadApplicationRolePermission: () => void
  readonly user: UserInfo
}) {
  const { applicationRolePermission, reloadApplicationRolePermission, user } = props
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    { field: "name", headerName: "Name" },
    { field: "label", headerName: "Value" },
  ]

  const canDelete = hasUserAccessToApplicationFeature(
    user.authorizations.applications,
    applicationRolePermission.application.id,
    DimaFeatureShortNameEnum.AM,
    AccessLevel.Write
  )

  const buildDeleteUrl = useCallback(
    (name: string, value: string) =>
      `/applications/${applicationRolePermission.application.id}/properties/${name}/values/${value}?roleId=${applicationRolePermission.role.id}&permissionId=${applicationRolePermission.permission.id}`,
    [
      applicationRolePermission.application.id,
      applicationRolePermission.role.id,
      applicationRolePermission.permission.id,
    ]
  )

  const rows = applicationRolePermission.properties.map(
    (property: ApplicationPropertyDetail, index: number) => ({
      id: index.toString(),
      name: property.name,
      label: property.label,
      deleteUrl: buildDeleteUrl(property.name, property.value),
    })
  )

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationRolePermission.application.id}/roles/${applicationRolePermission.role.id}/permissions/${applicationRolePermission.permission.id}/properties/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [applicationRolePermission]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(row.deleteUrl as string).then(() =>
            reloadApplicationRolePermission()
          )
        )
      }
    }, [reloadApplicationRolePermission, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={false}
        toolbar={toolbar}
        actionItems={
          canDelete
            ? [
                {
                  title: "Delete",
                  iconName: "icon_abb_dias icon-abb_delete",
                },
              ]
            : undefined
        }
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
